<template>
  <div class="container-fluid">
    <div class="row h-100">
      <!--
      ==================
       import sidebar
      ==================
     -->
      <Sidebar></Sidebar>
      <!--
      ==================
       dashboard page
      ==================
     -->
      <div class="col-sm p-0">
        <div class="_documents-new">
          <div class="container-page">
            <div class="content">
              <div class="_scrollbar_custom_">
                <div class="_documents__container" v-if="isLoading">
                  <half-circle-spinner
                    :animation-duration="1000"
                    :size="60"
                    color="#ff1d5e"
                  />
                </div>
                <div class=" __wrapper __header-collapse mb-4">
                  <div
                    class="d-flex justify-content-between"
                    v-b-toggle="'collapse-mandatory'"
                    style="width: 100%;"
                  >
                    <div>
                      <b>Mandatory Documents</b>
                      <p style="font-size: 12px; line-height: 0.7;">
                        These documents are mandatory for your account
                        verification.
                      </p>
                    </div>
                    <img
                      src="@/assets/image/icon/arrow-collapse.svg"
                      alt="arrow-down"
                      class="arrow"
                    />
                  </div>
                  <b-collapse class="pt-3" id="collapse-mandatory">
                    <div v-for="document in documentsData" :key="document.name">
                      <div class="__contents mt-2">
                        <div
                          class="d-flex justify-content-between align-items-center"
                          style="width: 100%; height: 100%;"
                        >
                          <div
                            class="d-flex flex-column justify-content-center"
                            style=""
                          >
                            <b>{{ document.title }}</b>
                            <p
                              v-if="document.info"
                              style="font-weight: 400; font-size: 12px; "
                            >
                              {{ document.info ? document.info : '' }}
                              <a
                                v-if="document.link"
                                href="https://www.insw.go.id/nib"
                                target="blank"
                                >https://www.insw.go.id/nib</a
                              >
                            </p>
                            <div
                              v-else-if="document.hasOwnProperty('type')"
                              class="d-flex justify-content-between align-items-center"
                            >
                              <b-form-radio-group
                                id="radio-group-3"
                                :disabled="disabledDocuments"
                                v-model="selectedDocument"
                                @input="chooseDocuments($event)"
                              >
                                <b-form-radio
                                  value="ktp"
                                  :disabled="disabledDocuments"
                                  ><p
                                    style="font-size: 12px; line-height: 2; font-weight: 600;"
                                  >
                                    KTP
                                  </p></b-form-radio
                                >
                                <b-form-radio
                                  style="margin-left: 20px;"
                                  value="passport"
                                  :disabled="disabledDocuments"
                                  ><p
                                    style="font-size: 12px; line-height: 2; font-weight: 600;"
                                  >
                                    Passport
                                  </p></b-form-radio
                                >
                              </b-form-radio-group>
                            </div>
                          </div>

                          <div class="d-flex _actions justify-content-between">
                            <div class="d-flex">
                              <img
                                v-if="!document.status"
                                class="status-icon mr-2"
                                src="@/assets/image/icon/status-grey.svg"
                                alt=""
                                height="11px"
                                width="11px"
                                style="line-height: 1.9;"
                              />
                              <img
                                v-else
                                class="status-icon mr-2"
                                src="@/assets/image/icon/status-green.svg"
                                alt=""
                                height="11px"
                                width="11px"
                                style="line-height: 1.9;"
                              />
                              <i>{{
                                !document.status ? 'Not Uploaded' : 'Uploaded'
                              }}</i>
                            </div>
                            <div class="d-flex ">
                              <div v-if="!document.status">
                                <!-- <img
                                  class="status-icon ml-4"
                                  src="@/assets/image/icon/download-grey.svg"
                                  alt=""
                                  height="14px"
                                  width="14px"
                                  style="line-height: 1.9;"
                                /> -->
                                <img
                                  class="status-icon ml-4"
                                  src="@/assets/image/icon/edit-grey.svg"
                                  alt=""
                                  height="14px"
                                  width="14px"
                                  style="line-height: 1.9;"
                                />
                                <img
                                  @click.prevent="toUpload(document.name)"
                                  class="status-icon ml-4"
                                  src="@/assets/image/icon/upload-green.svg"
                                  alt=""
                                  height="14px"
                                  width="14px"
                                  style="line-height: 1.9;"
                                />
                              </div>
                              <div v-else>
                                <!-- <img
                                  @click="viewDoc(document.url)"
                                  class="status-icon ml-4"
                                  src="@/assets/image/icon/file-blue.svg"
                                  alt=""
                                  height="14px"
                                  width="14px"
                                  style="line-height: 1.9;"
                                /> -->
                                <img
                                  v-if="
                                    (docs && docs.docs_status == 1) ||
                                      usersData.status ===
                                        'SALESVERIFICATION' ||
                                      usersData.status === 'ANDALINVERIFICATION'
                                  "
                                  class="status-icon ml-4"
                                  src="@/assets/image/icon/edit-grey.svg"
                                  alt=""
                                  height="14px"
                                  width="14px"
                                  style="line-height: 1.9;"
                                />
                                <img
                                  v-else
                                  @click.prevent="
                                    toReUpload(document.name, document.status)
                                  "
                                  class="status-icon ml-4"
                                  src="@/assets/image/icon/edit-text-blue.svg"
                                  alt=""
                                  height="14px"
                                  width="14px"
                                  style="line-height: 1.9;"
                                />
                                <img
                                  @click.prevent="
                                    downloadDoc(
                                      document.name,
                                      `${document.name}${document.status}`
                                    )
                                  "
                                  class="status-icon ml-4"
                                  src="@/assets/image/icon/Download-blue.svg"
                                  alt=""
                                  height="14px"
                                  width="14px"
                                  style="line-height: 1.9;"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <p class="mt-2" style="color: #C4232A;font-size: 14px;">
                      {{ messageOutput }}
                    </p>
                    <div
                      v-if="companyStatus === null"
                      class="d-flex justify-content-end mt-5"
                    >
                      <button
                        :disabled="disabledVerify"
                        @click="verification"
                        class="button button__bluecorporite"
                      >
                        Verify
                      </button>
                    </div>
                    <div
                      v-else-if="companyStatus === 'VERIFIED'"
                      class="d-flex justify-content-end mt-5"
                    >
                      <img src="@/assets/image/icon/VerifiedDoc.svg" alt="" />
                    </div>
                    <div
                      v-else-if="companyStatus === 'WAITING_FOR_VALIDATION'"
                      class="d-flex justify-content-end mt-5"
                    >
                      <button disabled class="button button__bluecorporite">
                        Waiting to be Verified
                      </button>
                    </div>
                  </b-collapse>
                </div>
                <div v-if="companyStatus === 'VERIFIED'">
                  <div class="__wrapper __header-collapse mb-4">
                    <div
                      class="d-flex justify-content-between"
                      style="width: 100%;"
                    >
                      <div style="margin-top: 6px;">
                        <b>{{
                          company.saf.status === null ||
                          company.saf.status === 'DRAFTED'
                            ? 'Fill in additional form for SAF and get your credit limit'
                            : 'Additional form for SAF ready to Sign'
                        }}</b>
                      </div>
                      <router-link
                        v-if="
                          company.saf.status === null ||
                            company.saf.status === 'DRAFTED'
                        "
                        to="/form-saf"
                        class="button__bluecorporite d-flex justify-content-center align-items-center"
                      >
                        Fill Now
                      </router-link>
                      <div
                        v-else-if="company.saf.status === 'SUBMITTED'"
                        class="d-flex justify-content-between align-items-center"
                        style="width: 25%;"
                      >
                        <div class="flex align-items-center">
                          <img
                            class="status-icon mr-2"
                            src="@/assets/image/icon/status-grey.svg"
                            alt=""
                            height="11px"
                            width="11px"
                            style="line-height: 1.9;"
                          />
                          <i>{{ 'Not Signed' }}</i>
                        </div>
                        <button
                          class="button__bluecorporite"
                          @click="modalSign"
                        >
                          Sign
                        </button>
                      </div>
                      <div
                        v-else-if="
                          company.saf.status === 'WAITING_FOR_VALIDATION'
                        "
                        class="d-flex justify-content-between align-items-center"
                        style="width: 25%;"
                      >
                        <div class="flex">
                          <img
                            class="status-icon mr-2"
                            src="@/assets/image/icon/status-grey.svg"
                            alt=""
                            height="11px"
                            width="11px"
                            style="line-height: 1.9;"
                          />
                          <i>{{ 'Waiting for Validation' }}</i>
                        </div>
                      </div>
                      <div
                        v-else-if="company.saf.status === 'APPROVED'"
                        class="d-flex justify-content-between align-items-center"
                        style="width: 25%;"
                      >
                        <div class="flex align-items-center">
                          <img
                            class="status-icon mr-2"
                            src="@/assets/image/icon/status-green.svg"
                            alt=""
                            height="11px"
                            width="11px"
                            style="line-height: 1.9;"
                          />
                          <i>{{ 'Signed' }}</i>
                        </div>
                        <b-spinner
                          v-if="isLoadingDocSafApproved"
                          small
                          variant="light"
                        />
                        <img
                          v-else
                          class="status-icon mr-2"
                          src="@/assets/image/icon/Download-blue.svg"
                          alt=""
                          height="14px"
                          width="14px"
                          style="line-height: 1.9;cursor: pointer;"
                          @click="downloadSafApproved"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="__wrapper __header-collapse">
                    <div
                      class="d-flex justify-content-between"
                      v-b-toggle="'collapse-mandatory-supp'"
                      style="width: 100%;"
                    >
                      <div>
                        <b>Supplementary Documents</b>
                        <p style="font-size: 12px; line-height: 0.7;">
                          These documents are optional.
                        </p>
                      </div>
                      <img
                        src="@/assets/image/icon/arrow-collapse.svg"
                        alt="arrow-down"
                        class="arrow"
                      />
                    </div>
                    <b-collapse class="pt-3" id="collapse-mandatory-supp">
                      <div
                        v-for="document in documentsDataSupp"
                        :key="document.name"
                      >
                        <div
                          v-if="document.name == 'type'"
                          class="__contents mt-2"
                          style="height:56px;"
                        >
                          <div
                            class="d-flex justify-content-between align-items-center"
                            style="width: 100%; height: 100%;"
                          >
                            <b
                              >What kind of company are you? (Please select
                              one)</b
                            >
                            <div class="d-flex justify-content-between">
                              <b-form-checkbox-group
                                id="radio-group-2"
                                v-model="selected"
                                name="radio-sub-component"
                                @input="chooseType($event)"
                                :disabled="disabled"
                                :checked="selected"
                              >
                                <b-form-checkbox
                                  value="PT"
                                  :disabled="disabled"
                                  class="mr-5"
                                  >PT</b-form-checkbox
                                >
                                <b-form-checkbox value="CV" :disabled="disabled"
                                  >CV</b-form-checkbox
                                >
                              </b-form-checkbox-group>
                            </div>
                          </div>
                        </div>
                        <div
                          v-else
                          class="__contents mt-2"
                          style="height:56px;"
                        >
                          <div
                            class="d-flex justify-content-between align-items-center"
                            style="width: 100%; height: 100%;"
                          >
                            <div
                              class="d-flex flex-column justify-content-center"
                            >
                              <b>{{ document.title }}</b>
                            </div>

                            <div
                              class="d-flex _actions justify-content-between"
                            >
                              <div class="d-flex">
                                <img
                                  v-if="!document.status"
                                  class="status-icon mr-2"
                                  src="@/assets/image/icon/status-grey.svg"
                                  alt=""
                                  height="11px"
                                  width="11px"
                                  style="line-height: 1.9;"
                                />
                                <img
                                  v-else
                                  class="status-icon mr-2"
                                  src="@/assets/image/icon/status-green.svg"
                                  alt=""
                                  height="11px"
                                  width="11px"
                                  style="line-height: 1.9;"
                                />
                                <i>{{
                                  !document.status ? 'Not Uploaded' : 'Uploaded'
                                }}</i>
                              </div>
                              <div class="d-flex ">
                                <div v-if="!document.status">
                                  <!-- <img
                                    class="status-icon ml-4"
                                    src="@/assets/image/icon/download-grey.svg"
                                    alt=""
                                    height="14px"
                                    width="14px"
                                    style="line-height: 1.9;"
                                  /> -->
                                  <img
                                    class="status-icon ml-4"
                                    src="@/assets/image/icon/edit-grey.svg"
                                    alt=""
                                    height="14px"
                                    width="14px"
                                    style="line-height: 1.9;"
                                  />
                                  <img
                                    @click.prevent="toUpload(document.name)"
                                    class="status-icon ml-4"
                                    src="@/assets/image/icon/upload-green.svg"
                                    alt=""
                                    height="14px"
                                    width="14px"
                                    style="line-height: 1.9;"
                                  />
                                </div>
                                <div v-else>
                                  <!-- <img
                                    @click="viewDoc(document.url)"
                                    class="status-icon ml-4"
                                    src="@/assets/image/icon/file-blue.svg"
                                    alt=""
                                    height="14px"
                                    width="14px"
                                    style="line-height: 1.9;"
                                  /> -->
                                  <img
                                    v-if="
                                      (docs && docs.docs_status == 1) ||
                                        usersData.status ===
                                          'SALESVERIFICATION' ||
                                        usersData.status ===
                                          'ANDALINVERIFICATION'
                                    "
                                    class="status-icon ml-4"
                                    src="@/assets/image/icon/edit-grey.svg"
                                    alt=""
                                    height="14px"
                                    width="14px"
                                    style="line-height: 1.9;"
                                  />
                                  <img
                                    v-else
                                    @click.prevent="
                                      toReUpload(document.name, document.status)
                                    "
                                    class="status-icon ml-4"
                                    src="@/assets/image/icon/edit-text-blue.svg"
                                    alt=""
                                    height="14px"
                                    width="14px"
                                    style="line-height: 1.9;"
                                  />
                                  <img
                                    @click.prevent="
                                      downloadDoc(
                                        document.name,
                                        `${document.name}${document.status}`
                                      )
                                    "
                                    class="status-icon ml-4"
                                    src="@/assets/image/icon/Download-blue.svg"
                                    alt=""
                                    height="14px"
                                    width="14px"
                                    style="line-height: 1.9;"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </b-collapse>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="_modals">
      <b-modal
        id="setting-form-address"
        ref="modalSign"
        hide-footer
        centered
        title="Choose Document Signing Methods"
      >
        <div>
          <p class="text-center mb-4">
            Select your preferred signing methods
          </p>
          <div
            class="d-flex align-items-center p-2 bg-saf mb-2"
            @click="showModalSignUpload('manual')"
          >
            <img
              class="status-icon ml-4 mr-2"
              src="@/assets/image/icon/Contract.svg"
              alt=""
              height="30px"
              width="30px"
              style="line-height: 1.9;"
            />
            <div class="text-left">
              <p style="font-size: 14px;font-weight: 600;">Sign Manually</p>
              <p style="font-size: 12px;">
                You must download document and sign before upload
              </p>
            </div>
          </div>
          <!-- <div class="d-flex align-items-center p-2 bg-disabled mb-2">
            <img
              class="status-icon ml-4 mr-2"
              src="@/assets/image/icon/takenajadisabled.svg"
              alt=""
              height="30px"
              width="30px"
              style="line-height: 1.9;"
            />
            <div class="text-left">
              <p style="font-size: 14px;font-weight: 600;color: #9EA1A4;">Sign with Tekenaja</p>
              <p style="font-size: 12px;color:#BEC2C5;">Sign digitaly with Tekenaja</p>
            </div>
          </div> -->
          <!-- <div class="d-flex align-items-center p-2 bg-saf mb-2" @click="showModalSignUpload('tekenaja')">
            <img
              class="status-icon ml-4 mr-2"
              src="@/assets/image/icon/tekenaja.svg"
              alt=""
              height="30px"
              width="30px"
              style="line-height: 1.9;"
            />
            <div class="text-left">
              <p style="font-size: 14px;font-weight: 600;color: #1B64CD;">Sign with Tekenaja</p>
              <p style="font-size: 12px;">Sign digitaly with Tekenaja</p>
            </div>
          </div> -->
        </div>
      </b-modal>
      <b-modal
        id="modalUploadDocumentSaf"
        ref="modalUploadDocument"
        centered
        hide-footer
        @hidden="resetModalUploadDoc"
        :title="viewModal === 'manual' ? 'Sign Manually' : 'Sign with Tekenaja'"
      >
        <div v-if="viewModal === 'manual'">
          <p class="mb-2 text-center" style="font-size: 14px;color: #686868;">
            <b>Important!</b> SAF document must be signed by the company
            director or managing director. Please download the SAF document
            below and sign each document page before uploading. Kindly send the
            hard copy to Andalin legal team after you sign SAF Document.
          </p>
          <div
            class="d-flex justify-content-between align-items-center p-2 bg-saf mb-2"
            @click="downloadSaf"
          >
            <div class="d-flex align-items-center">
              <img
                class="status-icon ml-4 mr-2"
                src="@/assets/image/icon/Contract.svg"
                alt=""
                height="30px"
                width="30px"
                style="line-height: 1.9;"
              />
              <p style="font-size: 14px;font-weight: 600;color: #1D3354;">
                Service Application Form (SAF)
              </p>
            </div>
            <img
              class="status-icon mr-2"
              src="@/assets/image/icon/Download-blue.svg"
              alt=""
              height="14px"
              width="14px"
              style="line-height: 1.9;"
            />
          </div>
          <div
            class="input__dragdrop"
            v-if="!Boolean(formDoc.fileDocument)"
            id="errorfile"
          >
            <b-form-file
              v-model="formDoc.fileDocument"
              style="cursor: pointer;"
              v-validate="'required'"
              name="fileDocumentShipment"
              :state="
                errors.first('fileDocumentShipment') &&
                  Boolean(formDoc.fileDocument)
              "
              accept=".pdf, .xls, .doc, .docx, .xlsx, .png, .jpeg"
              drop-placeholder="Drop file here..."
            >
              <template slot="placeholder">
                <img
                  class="input__dragdrop--img"
                  src="@/assets/image/icon/icon-upload-drag-drop.svg"
                  alt=""
                />
                <p class="mt-3">
                  Drag your file here or
                  <u style="color: #1E3354; font-weight: 700;">Choose file</u>
                </p>
                <p style="color: #C4232A">*Maximum 5 MB</p>
              </template>
            </b-form-file>
            <p class="textinfo text-left">{{ errorFormDoc.fileInput }}</p>
          </div>
          <div v-else-if="!statusForm">
            <!-- <p class="pb-1">Document Upload</p> -->
            <div
              class="input__dragdrop text-center p-4"
              style="border: 1px dashed rgb(196, 35, 42);"
            >
              <img
                class="input__dragdrop--img"
                src="@/assets/image/icon/icon-upload-drag-dropred.svg"
                alt=""
              />
              <p
                class="mt-3"
                style="color:rgb(196, 35, 42);font-style: normal;font-weight: normal;"
              >
                Sorry, your file is too big. Please upload file with maximum 5
                MB. <br />
                <u
                  style="color: #1E3354; font-weight: 700;cursor: pointer;"
                  @click="resetModalUploadDoc()"
                  >Choose file</u
                >
              </p>
            </div>
          </div>
          <div v-else>
            <div v-if="statusForm">
              <div
                v-if="
                  !progressBar.status &&
                    showProgressText(progressBar.value, progressBar.max) <= 100
                "
              >
                <p class="mb-2 text-left">Uploading</p>
                <b-progress :max="progressBar.max" show-progress>
                  <b-progress-bar
                    :value="progressBar.value"
                    :label="
                      `${showProgressText(
                        progressBar.value,
                        progressBar.max
                      )}% Uploading...`
                    "
                  ></b-progress-bar>
                </b-progress>
                <p class="mt-1 text-left">
                  Uploading your file, please wait...
                </p>
              </div>
              <div v-else>
                <p class="text-left">Your File:</p>
                <div class="d-flex mt-2 text-left">
                  <p
                    class="py-1"
                    style="cursor: pointer;color: #686868;font-size: 12px;"
                    @click="resetModalUploadDoc()"
                  >
                    <b><i>X</i></b>
                  </p>
                  <img
                    class="pl-2"
                    src="@/assets/image/icon/icon-file.svg"
                    alt=""
                  />
                  <p class="pl-2 py-1">
                    <i style="word-break: break-all;">{{
                      formDoc.fileDocument ? formDoc.fileDocument.name : ''
                    }}</i>
                  </p>
                </div>
                <div class="d-flex justify-content-center">
                  <button
                    class="button__bluecorporite mt-2"
                    :disabled="isActive"
                    @click="finishedSaf('upload')"
                  >
                    Upload
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <p class="mb-2" style="font-size: 14px;color: #686868;">
            <b>Important!</b> SAF document must be signed by the company
            director or managing director. Enter your Tekenaja ID to sign
            digitaly with Tekenaja.
          </p>
          <b-form-input
            v-model="tekenajaID"
            placeholder="Tekenaja ID"
            class="mb-4"
          />
          <div class="d-flex justify-content-center">
            <button
              class="button__bluecorporite mt-2"
              :disabled="submitTekenaja"
              @click="finishedSaf('submit')"
            >
              Submit
            </button>
          </div>
        </div>
      </b-modal>
      <b-modal
        id="modalUploadDocumentSaf"
        ref="modalSuccessUploadSaf"
        hide-header
        hide-footer
        hide-header-close
        centered
      >
        <div class="text-center">
          <img class="mb-2" src="@/assets/image/icon/success-blue.svg" alt="" />
          <p class="mb-2">
            {{
              modalStatus
                ? 'Success submits SAF Application. Our team will update you once the process is finished.'
                : 'Please check your email. We have sent a link to sign your SAF (Service Application Form) document in Tekenaja.'
            }}
          </p>
          <button
            v-if="modalStatus"
            @click="closeSuccessModal"
            class="button__bluecorporite"
          >
            Ok
          </button>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { HalfCircleSpinner } from 'epic-spinners';
import Sidebar from '@/components/global/Sidebar.vue';

export default {
  name: 'Documents',
  components: {
    Sidebar,
    HalfCircleSpinner
  },
  data() {
    return {
      options: [
        { text: 'PT', value: 'PT' },
        { text: 'CV', value: 'CV' }
      ],
      selectedDocument: {},
      selected: {},
      documentsData: [],
      documentsDataSupp: [],
      usersData: {},
      companyStatus: '',
      formDoc: {},
      progressBar: {
        value: 0,
        max: 0,
        status: false
      },
      statusForm: true,
      errorFormDoc: {
        fileInput: '',
        fileChategory: '',
        replyTo: '',
        desc: ''
      },
      isActive: true,
      submitTekenaja: true,
      viewModal: '',
      tekenajaID: '',
      modalStatus: true,
      messageOutput: ''
    };
  },
  computed: {
    ...mapGetters({
      account: 'settingAccount/account',
      company: 'settingCompany/company',
      docs: 'settingDocs/docs',
      error: 'settingDocs/error',
      isLoading: 'settingDocs/isLoading',
      errorUploadDocSaf: 'settingSaf/errorUploadDocSaf',
      users: 'settingUsers/users',
      // eslint-disable-next-line no-dupe-keys
      error: 'settingUsers/error',
      isLoadingDocSafApproved: 'settingSaf/isLoadingDocSafApproved'
      // eslint-disable-next-line no-dupe-keys
    }),
    disabled() {
      const data = this.documentsData.length;
      if (data >= 6 && this.documentsData[data - 1].status) {
        return true;
      } else {
        return false;
      }
    },
    disabledDocuments() {
      let disabled = false;
      if (this.documentsData[3].name && this.documentsData[3].status) {
        disabled = true;
      }
      return disabled;
    },
    disabledVerify() {
      let status = false;
      this.documentsData.forEach(el => {
        if (!el.status) {
          status = true;
        }
      });
      return status;
    },
    formFile() {
      return this.formDoc.fileDocument;
    }
  },
  async mounted() {
    await this.fetchDocs();
    await this.fetchCompanyProfile();
    await this.fetchAccount();
    await this.fetchUsers();
  },
  methods: {
    initialSetData() {
      if (this.account.countryName === 'Indonesia') {
        this.documentsData = [
          {
            name: 'npwp',
            title: 'NPWP Company',
            status: false,
            url: '',
            info: 'The NPWP should be registered in the ',
            link: 'https://www.insw.go.id/nib'
          },
          {
            name: 'nib',
            title: 'NIB',
            status: false,
            url: '',
            info: 'The NIB should be registered in the ',
            link: 'https://www.insw.go.id/nib'
          },
          {
            name: 'license',
            title: 'Business License',
            status: false,
            url: '',
            info: ''
          },
          {
            name: '',
            title:
              'Select between the available identification type (Managing Director/Director): ',
            type: false,
            status: false,
            url: ''
          }
        ];
        this.documentsDataSupp = [
          { name: 'siup', title: 'SIUP', status: false },
          { name: 'taxletter', title: 'Tax Exemption Letter', status: false },
          { name: 'financial', title: 'Financial Statements', status: false },
          { name: 'skkemenkumham', title: 'SK Kemenkumham', status: false },
          {
            name: 'type',
            title: 'What Kind of company are you? (Please Select One)',
            status: true
          }
        ];
      } else {
        this.documentsData = [
          {
            name: 'certificate',
            title: 'Incorporation Certificate',
            status: false
          },
          { name: 'license', title: 'Business License', status: false }
        ];
        this.documentsDataSupp = [
          { name: 'aoa', title: 'Article of Association', status: false },
          { name: 'taxletter', title: 'Tax Exemption Letter', status: false },
          {
            name: 'financial',
            title: 'Financial Statements (Optional)',
            status: false
          }
        ];
      }
    },
    async downloadDoc(type, name) {
      await this.$store.dispatch('settingDocs/DOWNLOAD_DOCS', {
        type: type,
        fileName: name
      });
    },
    async fetchAccount() {
      await this.$store.dispatch('settingAccount/FETCH_ACCOUNT');
    },
    viewDoc(url) {
      window.open(url, '_blank');
    },
    async verification() {
      if (this.selectedDocument) {
        await this.$store.dispatch('file/VERIFY_COMPANY_DOCUMENT');
        await this.fetchUsers();
        await this.fetchDocs();
        await this.fetchCompanyProfile();
      } else {
        this.messageOutput = ' Identification type is required';
      }
    },
    chooseType(checked) {
      if (this.documentsDataSupp.length < 6) {
        if (checked === 'CV') {
          this.documentsDataSupp.push({
            name: 'aoa',
            title: 'Article of Association',
            status: false,
            url: '',
            info: 'Akta Pendirian atau Anggaran Dasar Perusahaan'
          });
        } else {
          this.documentsDataSupp.push({
            name: 'sppkp',
            title: 'SPPKP',
            status: false,
            url: '',
            info:
              'Surat Pengukuhan Pengusaha Kena Pajak adalah surat yang diterbitkan oleh KPP yang berisikan identitas dan kewajiban perpajakan PKP'
          });
        }
      } else if (
        this.documentsDataSupp.length === 6 &&
        !this.documentsDataSupp[this.documentsDataSupp.length - 1].status
      ) {
        if (checked === 'CV') {
          this.documentsDataSupp[this.documentsDataSupp.length - 1] = {
            name: 'aoa',
            title: 'Article of Association',
            status: false,
            url: '',
            info: 'Akta Pendirian atau Anggaran Dasar Perusahaan'
          };
        } else {
          this.documentsDataSupp[this.documentsDataSupp.length - 1] = {
            name: 'sppkp',
            title: 'SPPKP',
            status: false,
            url: '',
            info:
              'Surat Pengukuhan Pengusaha Kena Pajak adalah surat yang diterbitkan oleh KPP yang berisikan identitas dan kewajiban perpajakan PKP'
          };
        }
      }
    },
    chooseDocuments(name) {
      this.documentsData[3].name = name;
    },
    toUpload(type, status) {
      this.messageOutput = '';
      if (!type) {
        this.messageOutput = ' Identification type is required';
        return;
      }
      const payload = {
        type: type,
        status: status
      };
      this.$eventHub.$emit('dialog-modal-document', payload);
    },
    toReUpload(type, status) {
      const payload = {
        type: type,
        status: status
      };
      this.$eventHub.$emit('dialog-confirmation-reupload', payload);
    },
    async fetchUsers() {
      await this.$store.dispatch('settingUsers/FETCH_USERS').then(() => {
        if (this.users) {
          this.usersData = this.users[0];
        }
      });
    },
    async fetchDocs() {
      await this.$store.dispatch('settingDocs/FETCH_DOCS');
    },
    async fetchCompanyProfile() {
      await this.$store.dispatch('settingCompany/FETCH_COMPANY').then(() => {
        if (this.company) {
          this.companyStatus = this.company.status;
        }
      });
    },
    modalSign() {
      this.$refs['modalSign'].show();
    },
    showModalSignUpload(data) {
      this.$refs['modalUploadDocument'].show();
      this.$refs['modalSign'].hide();
      this.viewModal = data;
    },
    resetModalUploadDoc() {
      this.formDoc.fileDocument = null;
      this.progressBar = {
        value: 0,
        max: 0,
        status: false
      };
      this.errorFormDoc = {
        fileInput: '',
        fileChategory: '',
        replyTo: '',
        desc: ''
      };
    },
    chkInputFile() {
      if (this.formDoc.fileDocument.size <= 5242880) {
        this.isActive = false;
        this.statusForm = true;
      } else {
        this.statusForm = false;
        this.isActive = true;
      }
    },
    startTimer() {
      let byte = 102400; // 100 kb to byte
      const vm = this.progressBar;
      const timer = setInterval(() => {
        // set kecepatan progress
        if (vm.max > 1048576) {
          // 1MB
          byte = 1048576;
        } else if (vm.max < 102400) {
          byte = 10240; // 10KB
        }
        // kalo ada ekor angka yang < byte, langsung nambain ekornya biar progress 100%
        if (vm.value + byte > vm.max) {
          vm.value += vm.max % byte;
        } else {
          vm.value += byte;
        }
        if (vm.value >= vm.max) {
          clearInterval(timer);
          vm.status = true;
        }
      }, 1000);
    },
    showProgressText(start, max) {
      return ((start / max) * 100).toFixed(0);
    },
    downloadSaf() {
      this.$store.dispatch('settingSaf/DOWNLOAD_SAF_DOCUMENT');
    },
    downloadSafApproved() {
      this.$store.dispatch('settingSaf/DOWNLOAD_SAF_DOCUMENT_APPROVED');
    },
    async finishedSaf(type) {
      if (type === 'upload') {
        const formData = new FormData();
        formData.append('fileDocument', this.formDoc.fileDocument);
        await this.$store
          .dispatch('settingSaf/UPLOAD_SAF_DOCUMENT', formData)
          .then(() => {
            if (!this.errorUploadDocSaf) {
              this.modalStatus = true;
              this.$refs['modalUploadDocument'].hide();
              this.$refs['modalSuccessUploadSaf'].show();
              this.fetchCompanyProfile();
            }
          });
      } else {
        this.modalStatus = false;
      }
      setTimeout(() => {
        this.$refs['modalSuccessUploadSaf'].hide();
      }, 2000);
    },
    closeSuccessModal() {
      this.$refs['modalSuccessUploadSaf'].hide();
      this.$refs['modalUploadDocument'].hide();
    }
  },
  watch: {
    // account () {
    //   this.initialSetData()
    // },
    docs(data) {
      if (data) {
        this.initialSetData();
        if (this.account.countryName === 'Indonesia') {
          if (this.documentsDataSupp.length < 6) {
            if (data.companyKind === 'CV') {
              this.selected = 'CV';
              this.documentsDataSupp.push({
                name: 'aoa',
                title: 'Article of Association',
                status: data.aoa,
                url: data.urlaoa,
                info: 'Akta Pendirian atau Anggaran Dasar Perusahaan'
              });
            } else if (data.companyKind === 'PT') {
              this.selected = 'PT';
              this.documentsDataSupp.push({
                name: 'sppkp',
                title: 'SPPKP',
                status: data.sppkp,
                url: data.urlsppkp,
                info:
                  'Surat Pengukuhan Pengusaha Kena Pajak adalah surat yang diterbitkan oleh KPP yang berisikan identitas dan kewajiban perpajakan PKP'
              });
            }
          } else {
            if (data.companyKind === 'CV') {
              this.selected = 'CV';
              this.documentsDataSupp[this.documentsDataSupp.length - 1] = {
                name: 'aoa',
                title: 'Article of Association',
                status: data.aoa,
                url: data.urlaoa,
                info: 'Akta Pendirian atau Anggaran Dasar Perusahaan'
              };
            } else if (data.companyKind === 'PT') {
              this.selected = 'PT';
              this.documentsDataSupp[this.documentsDataSupp.length - 1] = {
                name: 'sppkp',
                title: 'SPPKP',
                status: data.sppkp,
                url: data.urlsppkp,
                info:
                  'Surat Pengukuhan Pengusaha Kena Pajak adalah surat yang diterbitkan oleh KPP yang berisikan identitas dan kewajiban perpajakan PKP'
              };
            }
          }
        }

        this.documentsData.forEach(el => {
          if (el.name === 'npwp') {
            el.status = data.npwp;
            el.url = data.urlnpwp;
          } else if (!el.name) {
            if (data.ktp && !data.passport) {
              this.selectedDocument = 'ktp';
              el.name = 'ktp';
              el.status = data.ktp;
              el.url = data.urlktp;
            } else if (!data.ktp && data.passport) {
              this.selectedDocument = 'passport';
              el.name = 'passport';
              el.status = data.passport;
              el.url = data.urlpassport;
            }
          } else if (el.name === 'license') {
            el.status = data.license;
            el.url = data.urllicense;
          } else if (el.name === 'nib') {
            el.status = data.nib;
            el.url = data.urlnib;
          } else if (el.name === 'certificate') {
            el.status = data.certificate;
            el.url = data.urlcertificate;
          } else if (el.name === 'financial') {
            el.status = data.financial;
            el.url = data.urlfinancial;
          }
        });
        this.documentsDataSupp.forEach(el => {
          if (el.name === 'financial') {
            el.status = data.financial;
            el.url = data.urlfinancial;
          } else if (el.name === 'license') {
            el.status = data.license;
            el.url = data.urllicense;
          } else if (el.name === 'aoa') {
            el.status = data.aoa;
            el.url = data.urlaoa;
          } else if (el.name === 'siup') {
            el.status = data.siup;
            el.url = data.urlsiup;
          } else if (el.name === 'skkemenkumham') {
            el.status = data.skkemenkumham;
            el.url = data.urlskkemenkumham;
          } else if (el.name === 'taxletter') {
            el.status = data.taxletter;
            el.url = data.urltaxletter;
          } else if (el.name === 'aoa') {
            el.status = data.aoa;
            el.url = data.urlaoa;
          } else if (el.name === 'sppkp') {
            el.status = data.sppkp;
            el.url = data.urlsppkp;
          }
        });
      }
    },
    users(data) {
      if (data) {
        this.usersData = data[0];
      }
    },
    formFile(data) {
      if (data !== null) {
        this.progressBar.max = data.size;
        this.chkInputFile();
        if (this.statusForm) {
          this.startTimer();
        }
      }
    },
    tekenajaID(data) {
      this.submitTekenaja = !data;
    }
  }
};
</script>

<style>
.bg-saf {
  background: #fff;
  box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.16);
  border-radius: 4px;
  cursor: pointer;
}
.bg-disabled {
  background: #e5eaed;
  box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.16);
  border-radius: 4px;
  cursor: no-drop;
}
.bg-saf:hover {
  background: #ecf1f5;
}
.progress-bar {
  background: linear-gradient(
    92.79deg,
    #1e3354 73.13%,
    rgba(30, 51, 84, 0) 161.19%
  ) !important;
}
</style>



// WEBPACK FOOTER //
// src/view/settings/Documents.vue